import { ProductDiffType } from '../server/mpsklad_core/Entity/ProductDiffType'
import { MyProductDiffModel } from '../server/mpsklad_core/Models/MyProductDiffModel'

export const hasDiffType =
  (diff: MyProductDiffModel, targetDiffType: ProductDiffType) => {
    const testDiffType: ProductDiffType =
      (diff.types satisfies ProductDiffType) & (targetDiffType satisfies ProductDiffType)

    return testDiffType === targetDiffType
  }